import React from "react";
import { connect } from "react-redux";
import objectPath from "object-path";
import * as builder from "../../ducks/builder";
import KTToggle from "../../_assets/js/toggle";
import UserProfile from "../../../app/partials/layout/UserProfile";
import { RiChat2Line, RiMenu2Line } from "react-icons/ri";
import { expertsActions } from "../../../app/store/ducks/experts.duck";
import { withRouter } from "react-router-dom";

class HeaderMobile extends React.Component {
	toggleButtonRef = React.createRef();

	componentDidMount() {
		new KTToggle(this.toggleButtonRef.current, this.props.toggleOptions);
	}

	render() {
		const {
			asideDisplay,
			headerMobileCssClasses,
			headerMobileAttributes,
			location: { pathname },
			customClassName,
			experts: { chatList },
		} = this.props;

		return (
			<div id="kt_header_mobile" style={{ justifyContent: "flex-start" }} className={`kt-header-mobile ${headerMobileCssClasses} ${customClassName ?? ""}`} {...headerMobileAttributes}>
				<div className="kt-header-mobile__toolbar" style={{ display: "flex", justifyContent: "space-between", flex: "1" }}>
					{asideDisplay && (
						<>
							<div id="kt_aside_mobile_toggler">
								<RiMenu2Line size={32} color="#9CA3AF" style={{ cursor: "pointer" }} />
							</div>

							{pathname.includes("/experts") && chatList?.length ? (
								<div style={{ cursor: "pointer", marginLeft: 16, marginRight: "auto" }} onClick={() => this.props.loadShowMobileHistory()}>
									<RiChat2Line size={32} color="#9CA3AF" />
								</div>
							) : null}
						</>
					)}

					{/*
						// DESCOMENTAR CASO QUEIRA QUE O HEADER ALTERNATIVO VOLTE A FUNCIONAR
						{headerMenuSelfDisplay && (
							<button
							className="kt-header-mobile__toggler"
							id="kt_header_mobile_toggler"
							>
							<span />
							</button>
						)}
							*/}

					{/*
						// DESCOMENTAR CASO QUEIRA QUE O MOBILE TOPBAR DE VOLTA
						<button
							ref={this.toggleButtonRef}
							className="kt-header-mobile__topbar-toggler"
							id="kt_header_mobile_topbar_toggler"
						>
							<i className="flaticon-more" />
						</button>
						*/}

					<div className="user-profile-mobile">
						<UserProfile showAvatar={true} showHi={false} showBadge={false} />
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (store) => ({
	headerLogo: builder.selectors.getStickyLogo(store),
	asideDisplay: objectPath.get(store.builder.layoutConfig, "aside.self.display"),
	headerMenuSelfDisplay: objectPath.get(store.builder.layoutConfig, "header.menu.self.display") === true,
	toggleOptions: {
		target: "body",
		targetState: "kt-header__topbar--mobile-on",
		togglerState: "kt-header-mobile__toolbar-topbar-toggler--active",
	},
	headerMobileCssClasses: builder.selectors.getClasses(store, {
		path: "header_mobile",
		toString: true,
	}),
	headerMobileAttributes: builder.selectors.getAttributes(store, {
		path: "aside_menu",
	}),
	experts: store.experts,
});

const mapDispatchToProps = (dispatch) => ({
	loadShowMobileHistory: (status) => dispatch(expertsActions.loadShowMobileHistory(status)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderMobile));
